module.exports = __webpack_public_path__ + "static/media/muscle.e793e7f5.png";